<div class="form-group">
  <label for="prod-m">{{ 'form.user'| translate }}</label>
  <angular2-multiselect [data]="usersList"
      [(ngModel)]="userSelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onUserSelect()">
  </angular2-multiselect>
</div>